import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseDataService } from '../../shared/services/base-data.service';
import { AppConfigService } from '../../shared/services/app-config.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { LoaderService } from '../../shared/services/loader.service';
import { ResetPasswordRequest } from '../../authentication/models/reset-password.request';
import { ChangePasswordRequest } from '../../authentication/models/change-password.request';
import { ChangePasswordRequestNew } from '../../changepassword/models/changepassword.request'; 
import { LoginRequest } from '../../authentication/models/login.request';
import { AlertsHandlerService } from './alerts-handler.service';
import { LoginRes } from '../../authentication/models/login-res';
import { ApiResponse } from '../models/api-response.model';
import { ApiDataResponse } from '../models/api-data-response.model';
import { AuthenticationRequest } from '../../authentication/models/authentication.request';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationDataService extends BaseDataService {

  constructor(
    protected httpClient: HttpClient,
    protected appConfigService: AppConfigService,
    protected authenticationService: AuthenticationService,
    protected loaderService: LoaderService,
    protected alertsHandlerService: AlertsHandlerService
  ) {
    super(httpClient, appConfigService, loaderService, alertsHandlerService);
  }

  // public login(loginRequest: LoginRequest): Observable<string> {
  public login(loginRequest: LoginRequest): Observable<ApiDataResponse<LoginRes>> {
    // return this.post<string>('authentication/login', loginRequest, true);
    return this.post<ApiDataResponse<LoginRes>>('authentication/login', loginRequest, true);
  }

  public resetPassword(request: ResetPasswordRequest): Observable<void> {
    return this.post<void>('authentication/resetPassword', request, true);
  }

  public getUserEmailBySession(sessionKey: string): Observable<string> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('sessionKey', sessionKey);

    return this.get<string>('authentication/userEmailBySession', { params: httpParams }).pipe(
      map((response: string) => {
        return response;
      })
    );
  }

  public changePassword(request: ChangePasswordRequest): Observable<number> {
    return this.post<number>('authentication/completeResetPassword', request);
  }

  public changePasswordNew(request: ChangePasswordRequestNew): Observable<ApiResponse> {
    return this.post<ApiResponse>('authentication/changePassword', request);
  }

  public sendAuthenticationNumber(username: string): Observable<boolean> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('username', username);

    return this.get<boolean>('authentication/sendAuthenticationNumber', { params: httpParams }).pipe(
      map((response: boolean) => {
        return response;
      })
    );
  }

  public validateLogin(loginRequest: LoginRequest): Observable<boolean> {
    return this.post<boolean>('authentication/validateLogin', loginRequest, true);
  }

  public validateAuthenticationNumber(authRequest: AuthenticationRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('authentication/validateAuthenticationNumber', authRequest, true);
  }

  public clearAuthenticationNumber(username: string): Observable<boolean> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('username', username);

    return this.get<boolean>('authentication/clearAuthenticationNumber', { params: httpParams }).pipe(
      map((response: boolean) => {
        return response;
      })
    );
  }

  //Customer

  public customerLogin(loginRequest: LoginRequest): Observable<ApiDataResponse<LoginRes>> {
    return this.post<ApiDataResponse<LoginRes>>('authentication/customer/login', loginRequest, true);
  }

  public sendAuthenticationNumberCustomer(email: string): Observable<boolean> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('email', email);

    return this.get<boolean>('authentication/customer/sendAuthenticationNumber', { params: httpParams }).pipe(
      map((response: boolean) => {
        return response;
      })
    );
  }

  public validateLoginCustomer(loginRequest: LoginRequest): Observable<boolean> {
    return this.post<boolean>('authentication/customer/validateLogin', loginRequest, true);
  }

  public validateAuthenticationNumberCustomer(authRequest: AuthenticationRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('authentication/customer/validateAuthenticationNumber', authRequest, true);
  }

  public clearAuthenticationNumberCustomer(email: string): Observable<boolean> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('email', email);

    return this.get<boolean>('authentication/customer/clearAuthenticationNumber', { params: httpParams }).pipe(
      map((response: boolean) => {
        return response;
      })
    );
  }

  public getUserCodeByEmail(email: string): Observable<string> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('email', email);

    return this.get<string>('authentication/userCodeByEmail', { params: httpParams }).pipe(
      map((response: string) => {
        return response;
      })
    );
  }
}
